import React from 'react';

import { getFaqAutocompleteTiles } from '../util';
import { formatMetricValue } from '../../metrics/metrics-helpers';

import SearchSupportTiles from './search-support-tiles';
import './css/search-page-support.less';

const getGtmProps = (title, gtmId) => ({
    'data-gtm-category': 'linkClick',
    'data-gtm-id': gtmId,
    'data-gtm-value': formatMetricValue(title)
})

const GRID_PROPS = {
    gridColumns: 4,
    gridColumnsMobile: 6,
    gridColumnsTablet: 3,
}

const SearchStoreSupport = props => {
    const { supportResults, gtmConfig } = props;
    const { supportPages  } = supportResults || {};
    const gtmId = gtmConfig && gtmConfig.linkClick && gtmConfig.linkClick.gtmId
    const supportTiles = getFaqAutocompleteTiles(supportPages, null, gtmId, null, getGtmProps, GRID_PROPS)

    return supportTiles && (
        <div className='search-support-container'>
            <div className='search-support-tiles-container search-tiles-container'> 
                <div className='search-support-tiles'>
                    <SearchSupportTiles supportTiles={supportTiles.tiles} className={supportTiles.className}/>
                </div>
            </div>
        </div>
    );
}


export default SearchStoreSupport;